import PropTypes from 'prop-types';
import React from 'react';
import Autosuggest from 'react-autosuggest';
import { getAutoSuggestSearchApiJsonResponse } from '../../utils/commonUtils';
import { isEmpty } from '../../utils/isEmpty';

export const popularCities = [
  {
    title: 'POPULAR SEARCHES',
    citieslist: [
      {
        city: 'Delhi',
        state: 'Delhi',
        stationCode: 'NDLS',
        stationName: 'New Delhi Railway Station'
      },
      {
        city: 'Kolkata',
        state: 'West Bengal',
        stationCode: 'HWH',
        stationName: 'Kolkata Howrah Junction'
      },
      {
        city: 'Mumbai',
        state: 'Maharashtra',
        stationCode: 'KYN',
        stationName: 'Kalyan Junction'
      },
      {
        city: 'Chennai',
        state: 'Tamil Nadu',
        stationCode: 'MAS',
        stationName: 'Chennai Central Railway Station'
      },
      {
        city: 'Secunderabad',
        state: 'Telangana',
        stationCode: 'SC',
        stationName: 'Secunderabad Junction'
      },
      {
        city: 'Bangalore',
        state: 'Karnataka',
        stationCode: 'SBC',
        stationName: 'Bangalore City Junction'
      },
      {
        city: 'Pune',
        state: 'Maharashtra',
        stationCode: 'PUNE',
        stationName: 'Pune Junction'
      },
      {
        city: 'Ahmedabad',
        state: 'Gujarat',
        stationCode: 'ADI',
        stationName: 'Ahmedabad Junction'
      },
      {
        city: 'Patna',
        state: 'bihar',
        stationCode: 'PNBE',
        stationName: 'Patna Junction'
      },
      {
        city: 'Jaipur',
        state: 'Rajasthan',
        stationCode: 'JP',
        stationName: 'Jaipur Railway Station'
      }
    ]
  }
];

export const decorateStationsList = (response) => {
  const updatedStationsList = response.data.r.map((station) => {
    const {
      dn,
      irctc_code: irctcCode,
      xtr: { st_n: stateName, cn }
    } = station;
    return {
      ...station,
      city: cn,
      state: stateName,
      stationName: dn,
      stationCode: irctcCode
    };
  });
  return {
    ...response,
    data: { ...response.data, r: updatedStationsList }
  };
};

const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getSuggestions = (value) => {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp(`^${escapedValue}`, 'i');

  return popularCities
    .map((section) => ({
      title: section.title,
      citieslist: section.citieslist.filter((city) => regex.test(city.city))
    }))
    .filter((section) => section.citieslist.length > 0);
};

const shouldRenderSuggestions = () => true;

const getSuggestionValue = (suggestion) => suggestion.stationCode;

const renderSuggestion = (suggestion) => (
  <div className="makeFlex   column">
    <p className="searchedResult font14 darkText">
      <span className="sr_city">
        {suggestion.city}, {suggestion.state}
      </span>
      <span className="sr_iata grayText latoBold">{suggestion.stationCode}</span>
    </p>
    <p>
      <span className="sr_city">{suggestion.stationName}</span>
    </p>
  </div>
);

const renderSectionTitle = (section) => <p className="rsw_sectionTitle font12 latoBold grayText">{section.title}</p>;

const getSectionSuggestions = (section) => section.citieslist;

export async function searchStations(value) {
  const data = await getAutoSuggestSearchApiJsonResponse(value);
  return decorateStationsList(data);
}

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);

    getSuggestions('');

    this.state = {
      value: '',
      suggestions: popularCities
    };
  }

  // Wrapper function to avoid calling set State on unmounted component
  setStateWrapper = (latestStateObj) => {
    if (this.isUnmounted) {
      return;
    } else {
      this.setState(latestStateObj);
    }
  };

  onChange = (_, { newValue }) => {
    this.setStateWrapper({
      value: newValue
    });
  };

  _getStationsAutoComplete = async (value) => {
    const data = await searchStations(value);
    if (isEmpty(data.data.r)) {
      this.setStateWrapper({
        suggestions: [
          {
            title: 'No RESULTS FOUND',
            citieslist: []
          },
          popularCities[0]
        ]
      });
    } else {
      this.setStateWrapper({
        suggestions: [
          {
            title: 'SEARCH RESULTS',
            citieslist: data.data.r
          },
          popularCities[0]
        ]
      });
    }
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (value.length > 1) {
      this._getStationsAutoComplete(value);
    }
  };

  onSuggestionsClearRequested = () => {
    this.setStateWrapper({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    this.props.onChange(suggestion.city, suggestion.stationCode);
  };
  componentDidMount() {
    this.isUnmounted = false;
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  render() {
    const { placeholder } = this.props;
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder,
      value,
      autoFocus: true,
      onChange: this.onChange
    };

    return (
      <div className="rsw_autocomplePopup">
        <Autosuggest
          multiSection
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          renderSectionTitle={renderSectionTitle}
          getSectionSuggestions={getSectionSuggestions}
          shouldRenderSuggestions={shouldRenderSuggestions}
          inputProps={inputProps}
          focusInputOnSuggestionClick
          alwaysRenderSuggestions
        />
      </div>
    );
  }
}

AutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};

export default AutoComplete;
